module.exports = __webpack_public_path__ + "media/images/badge/infallibile_secondary-7855bb00c16098b457aec9e4071f905a.png";